export function search() {
  return {
    isOpen: false,
    searchQuery: '',
    
    openSearch() {
      this.isOpen = true;
      // Focus the search input after modal opens
      this.$nextTick(() => {
        this.$refs.searchInput?.focus();
      });
    },
    
    closeSearch() {
      this.isOpen = false;
      this.searchQuery = '';
    },
    
    handleSubmit() {
      if (this.searchQuery.trim()) {
        // Redirect to search results page with query
        window.location.href = `/search?q=${encodeURIComponent(this.searchQuery)}`;
      }
    }
  };
}